import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var FeedbackFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M9.1665 1.66663L8.52034 4.51493L6.26123 7.0247C5.9854 7.33053 5.83317 7.72794 5.83317 8.13961V15.8333C5.83317 16.7541 6.579 17.5 7.49984 17.5H14.1925C14.81 17.5 15.3691 17.1364 15.62 16.5722L18.1216 10.9423C18.2607 10.6307 18.3332 10.2928 18.3332 9.95113V9.16663C18.3332 8.24996 17.5832 7.49996 16.6665 7.49996H10.8332C10.8332 7.49996 11.6665 5.52436 11.6665 4.05269C11.6665 1.76769 9.1665 1.66663 9.1665 1.66663ZM1.6665 7.49996V17.5H4.1665V7.49996H1.6665Z",
    fill: fill
  }));
};
export { FeedbackFilled as default };
//# sourceMappingURL=FeedbackFilled.js.map
